import { useMemo } from 'react';
import { AvatarType } from '../components/Profile/types';

/**
 * Hook to get the user's avatar preference from localStorage
 * @returns The avatar type ('men' or 'women'), defaults to 'men' if not set
 */
export const useAvatar = (): AvatarType => {
	const avatar = useMemo(() => {
		try {
			const saved = localStorage.getItem('personalInformation');
			if (saved) {
				const parsed = JSON.parse(saved) as { avatar?: AvatarType };
				return parsed.avatar || 'men';
			}
			return 'men';
		} catch {
			return 'men';
		}
	}, []);

	return avatar;
};

